"use strict";

import links from "../components/links";

export default {
  init: () => {
    /**
     * Elemento modal
     */
    let modal = document.querySelector(".modal");

    var acc = document.getElementsByClassName("faq--list--item--question-info");
    for (let i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }

    /**
     * Abrir modal informações
     */
    let btnOpen = document.querySelector(".navigation--btns--modal");

    btnOpen.addEventListener("click", (e) => {
      e.preventDefault();
      modal.classList.add("show");
    });

    /**
     * Fechar modal informações
     */
    let btnClose = document.querySelector(".modal--content--header--close");

    btnClose.addEventListener("click", (e) => {
      e.preventDefault();
      modal.classList.remove("show");
    });

    /**
     * Abas modal bind
     */

    let btnsAba = document.querySelectorAll(".modal--content--buttons--btn");

    btnsAba.forEach((btn) => {
      btn.addEventListener("click", () => {
        btnsAba.forEach((btnRemove) => {
          btnRemove.classList.remove("active");
        });

        btn.classList.add("active");

        let abaActive = document.querySelector(
          `.modal--content--abas--aba.active`
        );
        abaActive && abaActive.classList.remove("active");

        let aba = document.querySelector(
          `.modal--content--abas--aba[data-aba="${btn.getAttribute(
            "data-ref"
          )}"]`
        );
        aba.classList.add("active");
      });
    });

    /**
     * Ativa primeira aba
     */

    // btnsAba[0].click();

    /**
     * custom params
     */

    let btnDetails = document.querySelector('[data-aba="detalhes"] a');

    if (btnDetails) {
      btnDetails.setAttribute(
        "href",
        btnDetails.getAttribute("href") + "&" + links.getParams()
      );
    }
  },
};
